
<div id="confirmApprovalModal" class="modal" class="modal" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-sm confirm-sm">
        <div class="modal-content">
            <div class="modal-header">Take Action
              <h4 class="modal-title"></h4>
              <button type="button" (click)="closeModal('confirmApprovalModal')" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body" >
                <form [formGroup]="approvalForm">
                    <div class="col-md-12 p-0">
                        <div class="form-container">
                            <div class = "form-field">
                                
                            </div>
                            <div class="form-field">
                                <mat-radio-group class="example-radio-group" formControlName="approvalType" aria-label="Select an option">
                                    <mat-radio-button class="example-radio-button" value="APPROVED">Approve</mat-radio-button>
                                    <mat-radio-button class="example-radio-button" value="REJECTED">Reject</mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <div class="form-field" *ngIf="approvalForm.controls['approvalType'].value=='REJECTED'">
                                <!-- <label class="form-label">Note:</label> <label class="form-label">Refund will be Intiated.</label><br> -->
                                <label class="form-label">Please enter your comments <span class="asteric">*</span></label>
                                <textarea rows="3" formControlName="comments" cols="3" class="form-control field-textarea"></textarea>
                                <div class="mat-error">
                                    <ng-container *ngIf="approvalForm.controls['comments'].touched && 
                                    approvalForm.controls['comments'].invalid ">
                                                    <small>White Space not allowed</small>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <ng-container>
                    <button class="btn save-btn" (click)="submitConfirmModal()"  [disabled]="isSubmitDisabled()">Submit</button>
                </ng-container>
            </div>
        </div>
    </div>
</div>